var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{staticClass:"moneyTextField",attrs:{"label":_vm.label,"disabled":_vm.disabled,"maxlength":"13","error-messages":_vm.errorMessages,"outlined":""},on:{"input":_vm.onInput},model:{value:(_vm.formattedValue),callback:function ($$v) {_vm.formattedValue=$$v},expression:"formattedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }